import { CreateEditJobNavEnum, CreateJobErrorTypes } from 'containers/jobs/constant';
import { CreateJobContextType } from 'containers/jobs/types';
import { FC, useContext } from 'react';
import ScheduleSection from './ScheduleSection';
import { getBorderStyles, getJobValidationErrors } from 'containers/jobs/utils';
import { useAppSelector } from 'hooks';
import { selectJobValidationErrors } from '../createJobSlice';
import AssignMembersCheckboxSection from './AssignMembersCheckboxSection';
import { selectIsFieldServePlus } from 'containers/subscriptions/modalSlice';
import AssignMembersSection from './AssignMembersSection';

interface ScheduleAndAssignToProps {
  context: React.Context<CreateJobContextType>;
  isEdit: boolean;
}

const ScheduleAndAssignTo: FC<ScheduleAndAssignToProps> = ({ context, isEdit }) => {
  const { selectedJobTab, setSelectedJobTab } = useContext<CreateJobContextType>(context);
  const isTabSelected = selectedJobTab === CreateEditJobNavEnum.JOB_SCHEDULE;

  const selectedJobValidations = useAppSelector(selectJobValidationErrors);
  const isFieldServePlus = useAppSelector(selectIsFieldServePlus);

  const hasError = Boolean(
    getJobValidationErrors(selectedJobValidations, CreateJobErrorTypes.SCHEDULE_DATE) ||
      getJobValidationErrors(selectedJobValidations, CreateJobErrorTypes.ASSIGN_MEMBER)
  );

  const handleOnFocus = () => {
    setSelectedJobTab(CreateEditJobNavEnum.JOB_SCHEDULE);
  };

  const borderStyle = getBorderStyles({
    isSelected: isTabSelected,
    hasError
  });

  return (
    <div className="w-full" onFocus={handleOnFocus}>
      <div className={`relative space-y-6 rounded-md border py-6 px-8 ${borderStyle}`}>
        <ScheduleSection isEdit={isEdit} />

        {isFieldServePlus ? (
          <AssignMembersCheckboxSection context={context} isEdit={isEdit} />
        ) : (
          <AssignMembersSection context={context} />
        )}
      </div>
    </div>
  );
};

export default ScheduleAndAssignTo;
